import store, { notificationType, keyStore } from "Store";

export interface INotifyParameter {
    type?: string,
    description?: string,
    buttonText?: string,
    image?: string,
    callBack?: Function
}

export interface IConfirmParameter {
    title?: string,
    message?: string,
    cancelButton?: string,
    acceptButton?: string,
    callBack?: Function,
}

export interface INotify {
    error(para: INotifyParameter): Promise<boolean>;
    success(para: INotifyParameter): Promise<boolean>;
    show(para: INotifyParameter): Promise<boolean>;
}

export class Notify implements INotify {
    error(para: INotifyParameter): Promise<boolean> {
        para.type = notificationType.error;
        return this.show(para);
    }
    success(para: INotifyParameter): Promise<boolean> {
        para.type = notificationType.success;
        return this.show(para);
    }
    show(para: INotifyParameter): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const temp = Object.assign({}, para);
            temp.callBack = function () {
                if (para.callBack != undefined) {
                    para.callBack();
                }
                resolve(true);
            }
            store.commit(keyStore.NOTIFICATION, temp);
        })
    }
}

export interface IConfirm {
    show(para: IConfirmParameter): Promise<boolean>
}

export class Confirm implements IConfirm {
    show(para: IConfirmParameter): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const temp = Object.assign({}, para);
            temp.callBack = function (result: any) {
                if (para.callBack != undefined) {
                    para.callBack();
                }
                resolve(result);
            }
            store.commit(keyStore.CONFIRM, temp);
        });
    }
}

export class Busy {
    setIsBusy(): void {
        store.commit(keyStore.ISBUSY, true);
    }
    clearIsBusy(): void {
        setTimeout(() => {
            store.commit(keyStore.ISBUSY, false);
        }, 500);
    }
    isBusy() : boolean {
       return store.getters[keyStore.ISBUSY];
    }
}